import React, { FC } from 'react';
import { SelectInput, useTranslate, SelectArrayInput, ReferenceArrayInput } from 'react-admin';
import { ReferenceInput, BranchSelect } from '~/components/ra';
import { l } from '~/utils/solutions';
import { useStyles } from '~/hooks/useSolutionsStyles';
import { Solution } from '~/types';
import { Configuration } from '~/api/solutions';

interface OnboardingFormProps {
  record: Solution;
  keyName: string;
  basePath: string;
  configurationRecord: Configuration;
}
export const OnboardingForm: FC<OnboardingFormProps> = ({
  record,
  keyName,
  basePath,
  configurationRecord,
}) => {
  const classes = useStyles();
  const translate = useTranslate();
  const t = (key: string): string => translate(l(`featuresConfig.${key}`));
  return (
    <>
      <ReferenceInput
        source={`${keyName}.product`} // deprecated
        reference='products'
        filter={{ solutionId: record.id }}
        basePath={basePath}
        label={t('defaultProduct')}
        className={classes.inputWidth}
        allowEmpty
      >
        <SelectInput optionText='name' />
      </ReferenceInput>
      <ReferenceInput
        source={`${keyName}.metaProduct`} // deprecated
        reference='products'
        filter={{ solutionId: record.id }}
        basePath={basePath}
        label={t('defaultMetaProduct')}
        className={classes.inputWidth}
        allowEmpty
      >
        <SelectInput optionText='name' />
      </ReferenceInput>
      {(keyName === 'veengu_individual_onboarding_dashboard' ||
        keyName === 'veengu_individual_onboarding_integration' ||
        keyName === 'veengu_business_onboarding_self' ||
        keyName === 'veengu_business_onboarding_dashboard' ||
        keyName === 'veengu_business_onboarding_integration') && (
        <ReferenceArrayInput
          source={`${keyName}.products`}
          reference='products'
          filter={{ solutionId: record.id }}
          basePath={basePath}
          label={t('defaultProducts')}
          className={classes.inputWidth}
          allowEmpty
        >
          <SelectArrayInput optionText='name' />
        </ReferenceArrayInput>
      )}
      {(keyName === 'veengu_individual_onboarding_integration' ||
        keyName === 'veengu_business_onboarding_self' ||
        keyName === 'veengu_business_onboarding_integration') && (
        <BranchSelect
          record={configurationRecord}
          source={`${keyName}.defaultBranch`}
          label={t('branch')}
          className={classes.inputWidth}
        />
      )}
    </>
  );
};
